// @media max width
const customMediaMaxWidthQuery = (maxWidth: number): string =>
  `@media (max-width: ${maxWidth / 16}em)`;

export const mediaMaxWidth = {
  custom: customMediaMaxWidthQuery,
  largeScreen: customMediaMaxWidthQuery(1919),
  mediumScreen: customMediaMaxWidthQuery(1536),
  desktop: customMediaMaxWidthQuery(1440),
  mediumDesktop: customMediaMaxWidthQuery(1199),
  smallDesktop: customMediaMaxWidthQuery(991),
  tablet: customMediaMaxWidthQuery(767),
  smallTablet: customMediaMaxWidthQuery(650),
  phone: customMediaMaxWidthQuery(500),
  smallPhone: customMediaMaxWidthQuery(320),
};

// @media min width
const customMediaMinWidthQuery = (minWidth: number): string =>
  `@media (min-width: ${minWidth / 16}em)`;

export const mediaMinWidth = {
  custom: customMediaMinWidthQuery,
  largeScreen: customMediaMinWidthQuery(1920),
  mediumScreen: customMediaMinWidthQuery(1537),
  desktop: customMediaMinWidthQuery(1441),
  mediumDesktop: customMediaMinWidthQuery(1200),
  smallDesktop: customMediaMinWidthQuery(992),
  tablet: customMediaMinWidthQuery(768),
  smallTablet: customMediaMinWidthQuery(650),
  phone: customMediaMinWidthQuery(501),
  smallPhone: customMediaMinWidthQuery(321),
};

// @media max height
const customMediaMaxHeightQuery = (maxHeight: number): string =>
  `@media (max-height: ${maxHeight / 16}em)`;

export const mediaMaxHeight = {
  custom: customMediaMaxHeightQuery,
  smallDesktop: customMediaMaxHeightQuery(760),
  phone: customMediaMaxHeightQuery(680),
  smallPhone: customMediaMaxHeightQuery(570),
};
